import {
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Stack,
  Image,
  Text,
  Box,
  
  
} from '@chakra-ui/react';
import axios from 'axios';
import { useToast } from '@chakra-ui/react'
import { useReducer } from 'react';
import { Navbar } from './Navbar';
import Footer from './Footer';
import { Navigate, useNavigate } from 'react-router-dom';
import Navbar2 from './Navbar2';




const iniitalstate={
  email:"",
  password:""
}
const reducer=(state,action)=>{
 switch(action.type){
  case "email":{
    return {...state,
      email:action.payload
    }
  }
  case "password":{
    return {...state,
      password:action.payload
    }
  }
  case "reset":{
    return    iniitalstate
  }
  default:{
  return    iniitalstate
  }
 }
}
export default function LoginPage() {
  const [state,dispach]=useReducer(reducer,iniitalstate)
  const navigate = useNavigate();
  const toast = useToast()
const handleclick=()=>{
   
  axios.post("https://actual-shoes-api.onrender.com/users/login",state)
  .then((res)=>{
    console.log(res)
    toast({
      position: 'top',
      title: 'Login Succesfully😎',
     
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
    localStorage.setItem("token",res.data.token)
    navigate("/singleuserPage")
  }).catch((err)=>{
    console.log(err.message)
    // alert("Wrong Crendential 😒")
    toast({
      position: 'top',
      title: 'Wrong Crendential 😒',
      description: "Please Check Your Details",
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
  })
  }
  const {email,password}=state

  return (<>
<Navbar2 />
  <Flex
    minH={'100vh'}
    align={'center'}
    justify={'center'}
    bgColor="#f7e9f"
  //   bg={useColorModeValue('gray.50', 'gray.800')}
  >
    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
      <Stack align={'center'}>
        <Heading style={{marginTop:"20px"}} fontSize={'4xl'}>Login Here!😎</Heading>
        <Text fontSize={'lg'} color={'gray.600'}>
          <Link color={'blue.400'}>StudentHelp</Link> ✌️
        </Text>
      </Stack>
      <Box
        rounded={'lg'}
      //   bg={useColorModeValue('white', 'gray.700')}
        boxShadow={'lg'}
        p={8}>
        <Stack spacing={4}>
          <FormControl position="static" id="email">
            <FormLabel >Email address</FormLabel>
            <Input type="email" value={email} onChange={(e)=>dispach({type:"email",payload:e.target.value})} />
          </FormControl>
          <FormControl position="static" id="password">
            <FormLabel>Password</FormLabel>
            <Input type="password" value={password} onChange={(e)=>dispach({type:"password",payload:e.target.value})} />
          </FormControl>
          <Stack spacing={10}>
            <Stack
              direction={{ base: 'column', sm: 'row' }}
              align={'start'}
              justify={'space-between'}>
              <Checkbox position="static">Remember me</Checkbox>
              <Link color={'blue.400'}>Forgot password?</Link>
            </Stack>
            <Button position="static"
              bg={'blue.400'}
              color={'white'}
              onClick={handleclick}
              _hover={{
                bg: 'blue.500',
               
              }}>
              Log in
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  </Flex>
   <Footer />
    </>);
}